<template>
    <div>
      <q-form ref="editForm">
        <div class="row">
          <div class="col-12">
            <c-card title="기준정보" class="cardClassDetailForm work-card" :noMarginPadding="true">
              <template slot="card-description">
                <font v-if="workPermit.swpWorkRequestCd" class="text-negative" style="font-size:0.8em;font-weight:300;">
                  ({{workRequestDescription}})
                </font>
              </template>
              <template slot="card-button">
                <q-btn-group outline >
                  <c-btn
                    v-show="isWorkInfo"
                    label="댓글"
                    icon="chat_bubble_outline"
                    @btnClicked="() => { drawer = !drawer }" />
                  <c-btn
                    v-show="isOld"
                    label="출력"
                    icon="print"
                    @btnClicked="printWorkPermit" />
                  <!-- [S]결재관련 버튼 -->
                  <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
                  <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
                  <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
                  <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
                  <!-- <c-appr-btn 
                    ref="appr-btn"
                    name="work-permit-appr-btn"
                    :editable="editable"
                    :approvalInfo="approvalInfo"
                    @beforeApprAction="approvalWorkPermit"
                    @callbackApprAction="approvalWorkPermitCallback"
                    @requestAfterAction="getDetail('save')"
                  /> -->
                  <!-- [E]]결재관련 버튼 -->
                  <c-btn
                    v-show="isOld"
                    label="전달내용"
                    icon="mail_outline"
                    @btnClicked="vendorSendDialogOpen" />
                  <c-btn
                    v-show="workPermit.returnRemark"
                    label="반려사유"
                    icon="keyboard_return"
                    @btnClicked="returnDialogOpen" />
                  <c-btn
                    v-show="editable && isWriting && isOld && !popupParam.isApprContent && !workPermit.sysApprovalRequestId && !disabled"
                    label="삭제"
                    icon="remove"
                    @btnClicked="removeWorkPermit" />
                  <c-btn
                    v-show="editable && !disabled && isWriting" 
                    :isSubmit="isSave"
                    :url="saveUrl"
                    :param="workPermit"
                    :mappingType="mappingType"
                    :label="saveBtnLabel"
                    icon="save"
                    @beforeAction="saveWorkPermit"
                    @btnCallback="saveWorkPermitCallback" />
                  <c-btn
                    v-show="editable && isOld && !disabled" 
                    :isSubmit="isRequest"
                    :url="requestUrl"
                    :param="workPermit"
                    mappingType="PUT"
                    :label="requestBtnLabel"
                    icon="check"
                    @beforeAction="requestWorkPermit"
                    @btnCallback="requestWorkPermitCallback" />
                  <c-btn
                    v-show="editable && isOld && !rejectDisabled" 
                    :isSubmit="isReject"
                    :url="rejectUrl"
                    :param="workPermit"
                    mappingType="PUT"
                    label="승인요청 취소"
                    icon="check"
                    @beforeAction="rejectWorkPermit"
                    @btnCallback="rejectWorkPermitCallback" />
                </q-btn-group>
              </template>
              <template slot="card-detail">
                <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item">
                  <c-plant
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    label="사업장"
                    name="plantCd"
                    v-model="workPermit.plantCd">
                  </c-plant>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item">
                  <c-text
                    :disabled="true"
                    :editable="editable"
                    label="허가번호"
                    name="permitNo"
                    v-model="workPermit.permitNo">
                  </c-text>
                </div>
                <div class="col-xs-12 col-sm-2 col-md-1 col-lg-1 work-item">
                  <c-checkbox
                    :disabled="!isWriting"
                    :editable="editable"
                    :isFlag="true"
                    label="기간 여부"
                    name="periodFlag"
                    v-model="workPermit.periodFlag"
                    @datachange="changePeriodFlag"
                  />
                </div>
                <div v-if="workPermit.periodFlag==='Y'" class="col-xs-12 col-sm-6 col-md-3 col-lg-3 work-item">
                  <c-datepicker
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :range="true"
                    :minuteStep="10"
                    type="datetime"
                    label="허가작업일정"
                    name="permitPeriod"
                    v-model="workPermit.permitPeriod"
                  />
                </div>
                <div v-if="workPermit.periodFlag==='N'" class="col-xs-12 col-sm-2 col-md-1 col-lg-1 work-item">
                  <c-datepicker
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    label="허가작업일"
                    name="permitDate"
                    v-model="workPermit.permitDate"
                  />
                </div>
                <div v-if="workPermit.periodFlag==='N'" class="col-xs-12 col-sm-4 col-md-2 col-lg-2 work-item">
                  <c-datepicker
                    :required="true"
                    :disabled="!isWriting"
                    :editable="editable"
                    :range="true"
                    :minuteStep="10"
                    type="time"
                    label="작업시간"
                    name="workTime"
                    v-model="workPermit.workTime"
                  />
                </div>
                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 work-item">
                  <c-multi-select
                    :disabled="!isWriting"
                    :editable="editable"
                    codeGroupCd="SOP_SUPPLEMENT_WORK_TYPE_CD"
                    itemText="codeName"
                    itemValue="code"
                    label="보충작업"
                    name="supWorks"
                    v-model="supWorks"
                    @datachange="changeSupWork">
                  </c-multi-select>
                </div>
                <template v-if="isWorkInfo">
                  <q-slide-transition >
                    <div v-show="visible" class="row" style="display:-webkit-inline-box;width:100%;">
                      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <q-card class="work-card" flat bordered
                          :class="cancelFlag ? 'bg-highLight' : ''">
                          <q-card-section class="q-pa-xs q-pl-sm bg-grey-3"
                            :class="this.editable&&!this.disabled&&!this.disableCancel ? 'cursor-pointer' : 'cursor-not-allowed'"
                            v-on:click="qCardCancelClick">
                            <div class="text-orange-9 work-title-text">
                              <q-checkbox
                                size="22px"
                                v-model="cancelFlag"
                                label=""
                                :disable="disableCancel||disabled||!editable"
                                @input="changeCancel" />
                              취소
                            </div>
                          </q-card-section>
                          <q-separator />
                          <q-card-section class="no-padding row">
                            <div class="col-12 work-item">
                              <c-textarea
                                :required="cancelFlag"
                                :editable="editable"
                                :disabled="disabled || !cancelFlag"
                                :rows="4"
                                label="취소사유"
                                beforeText=""
                                name="cancelRemark"
                                v-model="workPermit.cancelRemark" />
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
                        <q-card class="work-card" flat bordered
                          :class="overFlag ? 'bg-highLight' : ''">
                          <q-card-section
                            class="q-pa-xs q-pl-sm cursor-pointer bg-grey-3"
                            style="position: relative;">
                            <div style="position:absolute;right: 10px;top: 3px;z-index: 10600">
                              <q-btn-group outline >
                                <c-btn v-if="editable&&overFlag&&!disabled" label="추가" icon="add" :showLoading="false" @btnClicked="addOver" />
                                <c-btn v-if="editable&&overFlag&&!disabled" label="제외" icon="remove" :showLoading="false" @btnClicked="removeOver" />
                              </q-btn-group>
                            </div>
                          </q-card-section>
                          <q-card-section class="q-pa-xs q-pl-sm bg-grey-3"
                            style="min-height:23px;"
                            :class="this.editable&&!this.disabled ? 'cursor-pointer' : 'cursor-not-allowed'"
                            v-on:click="qCardOverClick">
                            <div class="text-orange-9 work-title-text float-left"
                              style="position:absolute;top: -3px;">
                              <q-checkbox
                                size="22px"
                                v-model="overFlag"
                                label=""
                                :disable="disabled"
                                @input="changeOver" />
                              연장
                            </div>
                          </q-card-section>
                          <q-separator />
                          <q-card-section class="no-padding row" style="width:100%">
                            <div class="col-12">
                              <c-table
                                class="work-permit-table"
                                ref="tableOver"
                                title=""
                                tableId="01"
                                :columns="grid.columns"
                                :data="workPermit.overs"
                                :gridHeight="grid.height"
                                :editable="editable&&overFlag&&!disabled"
                                :tableTimePickerOptions="tableTimePickerOptions"
                                :filtering="false"
                                :columnSetting="false"
                                :usePaging="false"
                                :isTitle="false"
                                :hideHeader="false"
                                :hideBottom="true"
                                :noHighLight="true"
                                :noHoverRow="true"
                                selection="multiple"
                                rowKey="sopOverResultId"
                              >
                              </c-table>
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 grid-style-transition">
                        <q-card class="work-card" flat bordered
                          :class="completeFlag ? 'bg-highLight' : ''">
                          <q-card-section class="q-pa-xs q-pl-sm bg-grey-3"
                            :class="this.editable&&!this.disabled&&!this.disableComplete ? 'cursor-pointer' : 'cursor-not-allowed'"
                            v-on:click="qCardCompleteClick">
                            <div class="text-orange-9 work-title-text">
                              <q-checkbox
                                size="22px"
                                v-model="completeFlag"
                                label=""
                                :disable="disableComplete||disabled"
                                @input="changeComplete" />
                              완료
                            </div>
                          </q-card-section>
                          <q-separator />
                          <q-card-section class="no-padding row">
                            <div class="col-4 work-item">
                              <c-datepicker
                                :required="completeFlag"
                                :editable="editable"
                                :disabled="disabled||!completeFlag"
                                :minuteStep="10"
                                type="time"
                                label="완료시간"
                                beforeText=""
                                name="workCompleteTime"
                                v-model="workPermit.workCompleteTime"
                              />
                            </div>
                            <div class="col-4 work-item">
                              <c-field
                                :required="completeFlag"
                                :editable="editable"
                                :disabled="disabled||!completeFlag"
                                :data="workPermit"
                                deptValue="workCompleteEntryDeptCd"
                                type="dept_user"
                                label="확인자"
                                beforeText=""
                                name="workCompleteEntryUserId"
                                v-model="workPermit.workCompleteEntryUserId" />
                            </div>
                            <div class="col-4 work-item">
                              <c-field
                                :required="completeFlag"
                                :editable="editable"
                                :disabled="disabled||!completeFlag"
                                :data="workPermit"
                                deptValue="workCompleteWorkDeptCd"
                                type="dept_user"
                                label="작업자"
                                beforeText=""
                                name="workCompleteWorkUserId"
                                v-model="workPermit.workCompleteWorkUserId" />
                            </div>
                            <div class="col-12 work-item">
                              <c-text
                                :editable="editable"
                                :disabled="disabled||!completeFlag"
                                label="조치사항"
                                beforeText=""
                                name="actionRemark"
                                v-model="workPermit.actionRemark" />
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                    </div>
                  </q-slide-transition>
                  <div class="col-12 folder-area">
                    <q-btn
                      style="width:100%"
                      size="2px"
                      color="light-blue"
                      :icon="folderIcon"
                      @click="folder" />
                  </div>
                </template>
              </template>
            </c-card>
          </div>
        </div>
      </q-form>
      <c-tab
        class="q-mt-sm"
        type="tabcard"
        align="left"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        :dense="true"
        :height="cusTabHeight"
        v-model="tab"
      >
        <template v-slot:default="tab">
          <component
            ref="swp-tab"
            :is="tab.component"
            :key="tab.componentKey"
            :workPermit.sync="workPermit"
            :supWork.sync="tab.supWork"
            :isOld="isOld"
            :isWriting="isWriting"
            :saveAction="saveAction"
            :height="cusTabHeight"
            @validResult="validResult"
          />
        </template>
        <template v-slot:customTab>
          <q-tab
            name="references"
            icon="description"
            label="관련정보">
          </q-tab>
        </template>
        <template v-slot:customTabPanel>
          <q-tab-panel
            name="references">
            <keep-alive>
              <component
                :is="referencesCompo"
                :key="referencesKey"
                :workPermit.sync="workPermit"
                :supWorks.sync="supWorks"
                :gasEditable.sync="gasEditable"
                :saveCall.sync="saveCall"
                :isWriting="isWriting"
                :height="tabHeight"
              />
            </keep-alive>
          </q-tab-panel>
        </template>
      </c-tab>
      <c-comments
        :disabled="!isWorkInfo"
        :editable="editable"
        :commentsInfo="commentsInfo"
        name="workpermitComments"
        v-model="drawer"
      />
      <q-dialog v-model="returnDialog.show" persistent>
        <q-card style="min-width: 450px">
          <q-form ref="editForm2">
            <c-card title="반려 사유" class="cardClassDetailForm">
              <template slot="card-button">
                <q-btn-group outline >
                  <c-btn 
                    label="닫기" 
                    icon="cancel" 
                    @btnClicked="closeDialog"
                  />
                </q-btn-group>
              </template>
              <template slot="card-detail">
                <div class="col-12">
                  <c-textarea
                    :editable="editable"
                    :readonly="true"
                    :rows="5"
                    label=""
                    name="returnRemark"
                    v-model="workPermit.returnRemark">
                  </c-textarea>
                </div>
              </template>
            </c-card>
          </q-form>
        </q-card>
      </q-dialog>
      <q-dialog v-model="vendorSendDialog.show" persistent>
        <q-card style="min-width: 450px;">
          <q-form ref="editForm2">
            <c-card title="전달 내용" class="cardClassDetailForm">
              <template slot="card-button">
                <q-btn-group outline >
                  <c-btn 
                    label="닫기" 
                    icon="cancel" 
                    @btnClicked="closeVendorSendDialog"
                  />
                </q-btn-group>
              </template>
              <template slot="card-detail">
                <div class="col-12">
                  <c-textarea
                    :editable="editable"
                    :readonly="true"
                    :rows="5"
                    label=""
                    name="vendorComment"
                    v-model="workPermit.vendorComment">
                  </c-textarea>
                </div>
              </template>
            </c-card>
          </q-form>
        </q-card>
      </q-dialog>
      <c-dialog :param="popupOptions"></c-dialog>
    </div>
  </template>
  <script>
  import { uid } from 'quasar'
  import eventBus from '@/js/eventBus';
  import selectConfig from '@/js/selectConfig';
  import transactionConfig from '@/js/transactionConfig';
  import transactionPartnerConfig from '@/js/transactionPartnerConfig';
  export default {
    name: 'safe-work-permit-detail',
    props: {
      popupParam: {
        type: Object,
        default(){
          return {
            sopWorkPermitId: '',
            permitTypeCd: '',
            isApprContent: false,
            approvalDocType: '',
          }
        },
      },
      contentHeight: {
        type: [String, Number],
        default: function() {
          return 'auto'
        },
      }
    },
    data() {
      return {
        workPermit: {
          sopWorkPermitId: '',  // 작업허가서 일련번호
          plantCd: '',  // 사업장 코드
          sopName: '',  // 작업명
          mdmSopId: '',  // 안전작업 표준 일련번호_SOP에서 불러와서 관련 정보 표시후 수정
          permitNo: '',  // 허가번호_(YYYYMMDD-01)
          swpStepCd: '',  // 진행단계 코드
          applicationDeptCd: '',  // 신청인 부서코드
          applicationDeptName: '',
          applicationUserId: '',  // 신청인 ID
          applicationUserName: '',
          workManagerId: '',
          workManagerDeptCd: '',
          emergencyContact: '', // 비상연락처
          permitTypeCd: '',  // 허가서 구분_화기/일반
          periodFlag: 'N',
          permitDate: '',  // 허가일
          permitEndDate: '',  // 허가종료일
          permitPeriod: [], // 허가기간
          workStartTime: '', // 작업시작시간
          workEndTime: '', // 작업종료시간
          workTime: [], // 작업시간
          processCd: '',  // 작업공정
          workLocation: '',  // 작업장소
          equipmentCd: '',  // 설비번호_설비마스터
          workSummary: '',  // 작업개요
          specialRequirements: '',  // 특별요구사항
          cancelRemark: '',  // 취소사유
          actionRemark: '',  // 조치사항
          maintenanceDeptCheckUserId: '',  // 정비부서 책임자 - 안전조치확인
          maintenanceDeptEntryUserId: '',  // 정비부서 입회자 - 안전조치확인
          workCompleteTime: '',  // 작업완료시간
          workCompleteEntryUserId: '',  // 작업완료 입회자/확인자
          workCompleteWorkUserId: '',  // 작업완료 작업자
          issuedDeptCd: '',  // 발급자 부서코드
          issuedUserId: '',  // 발급자 ID
          approvalDeptCd: '',  // 승인자 부서코드
          approvalUserId: '',  // 승인자 ID
          relationCooperation1DeptCd: '',  // 관련부서 협조자1 부서코드
          relationCooperation1UserId: '',  // 관련부서 협조자1 ID
          relationCooperation2DeptCd: '',  // 관련부서 협조자2 부서코드
          relationCooperation2UserId: '',  // 관련부서 협조자2 ID
          vendorCd: '',  // 작업업체 코드
          swpWorkClassCd: null,  // 작업구분 코드
          workLocationFlag: 'N',  // 작업장소 구분
          overWorkFlag: '',  // 연장작업 여부
          psmFlag: 'N',  // PSM 관련 여부
          sopMocId: '',  // MOC 일련번호
          assessWriteUserId: '',  // 작업위험성평가_작성자 ID
          assessApprovalUserId: '',  // 작업위험성평가_승인자 ID
          hazardPreventionPlanCd: '',  // 유해위험방지계획서
          swpWorkRequestCd: '',  // 작업허가요청
          swpWorkRequestType: '',  // 작업허가요청
          returnRemark: '', // 반려사유
          vendorComment: '', // 반려사유
          regUserId: '',  // 등록자 ID
          chgUserId: '',  // 수정자 ID
          supWorks: [],
          deleteSupWorks: [],
          checkResults: [],
          deleteCheckResults: [],
          gases: [], // 조회용
          gasChecks: [], // 저장용
          deleteGasChecks: [],
          deleteGasCheckVals: [],
          maps: [],
          deleteMaps: [],
          workers: [],
          deleteWorkers: [],
          assessments: [],
          deleteAssessments: [],
          overs: [],
          deleteOvers: [],
          protectiveGears: [],
          deleteProtectiveGears: [],
          safetyCertifications: [],
          autoSafetyConfirms: [],
          assessUsers: [],
          deleteAssessUsers: [],
          approvalStatusCd: '', // 결재관련 결재상태
          sysApprovalRequestId: '', // 결재관련 결재요청코드
  
          isClosedSpaceEquip: false,
        },
        supWorks: [],
        cusTabHeight: '',
        visible: false,
        folderIcon: 'expand_more',
        tab: '',
        tabItems: [],
        grid: {
          columns: [
            {
              name: 'overTime',
              field: 'overTime',
              label: '시간',
              align: 'center',
              style: 'width:100px',
              sortable: true,
              type: 'datetime',
              minuteStep: 10,
            },
            {
              name: 'overReason',
              field: 'overReason',
              label: '사유',
              align: 'left',
              style: 'width:300px',
              sortable: true,
              type: 'text',
            },
          ],
          data: [],
          height: '130px'
        },
        returnDialog: {
          show: false,
        },
        vendorSendDialog: {
          show: false,
        },
        gasItems: [],
        cancelFlag: false,
        overFlag: false,
        completeFlag: false,
        disableCancel: false,
        disableComplete: false,
        saveAction: '',
        editable: true,
        detailUrl: '',
        listGasItemUrl: '',
        listSopDefaultUrl: '',
        saveUrl: '',
        deleteUrl: '',
        approvalUrl: '',
        overUrl: '',
        cancelUrl: '',
        completeUrl: '',
        requestUrl: '',
        rejectUrl: '',
        printUrl: '',
        isSave: false,
        isRequest: false,
        isReject: false,
        isApproval: false,
        mappingType: 'POST',
        saveCall: {
          saveCallData: '',
        },
        drawer: false,
        commentsInfo: {
          taskClassCd: 'CTT0000001',
          taskKey: '',
        },
        popupOptions: {
          isFull: true,
          isApproval: true,
          target: null,
          title: '',
          visible: false,
          param: {},
          closeCallback: null,
        },
      };
    },
    beforeCreate() {},
    created() {},
    beforeMount() {
      Object.assign(this.$data, this.$options.data());
    },
    mounted() {
      this.init();
    },
    beforeDestory() {
    },
    computed: {
      tabHeight() {
        let margin = 175;
        if (this.isWorkInfo) {
          margin += 30;
        }
        if (this.visible) {
          margin = Number(margin) + 160
        } else {
          margin = Number(margin)
        }
        return String(this.contentHeight - margin) + 'px';
      },
      overTimeOption() {
        let returnData = {
          start: '17:00', // this.$comm.moment(this.wkodMaster.workEndTime, 'HH:mm').add('10', 'm').format('HH:mm'),
          step: '00:10',
          end: '23:50'
        };
        if (this.workPermit.overs && this.workPermit.overs.length > 0) {
          returnData.start = this.workPermit.overs[this.workPermit.overs.length - 1].overTime
        }
        return returnData;
      },
      isOld() {
        return Boolean(this.popupParam.sopWorkPermitId)
      },
      referencesCompo() {
        return () => import(`${'./swpReferences.vue'}`);
      },
      referencesKey() {
        return uid();
      },
      disabled() {
        // 모든 입력폼이 비활성화 되는 상황
        // - 취소  - 작업완료
        // - 결재중
        return this.isOld 
              // - 취소  - 작업완료
          && (this.workPermit.swpStepCd === 'SS00000015' || this.workPermit.swpStepCd === 'SS00000020' 
            // 결재중인 경우 비활성화
            || this.workPermit.approvalStatusCd === 'ASC0000001'
            // 작업허가요청이 진행중인 경우
            || Boolean(this.workPermit.swpWorkRequestCd))
      },
      rejectDisabled() {
        // 모든 입력폼이 비활성화 되는 상황
        // - 취소  - 작업완료
        // - 결재중
        return this.isOld 
              // - 취소  - 작업완료
          && (this.workPermit.swpStepCd === 'SS00000015' || this.workPermit.swpStepCd === 'SS00000020' 
            // 결재중인 경우 비활성화
            || this.workPermit.approvalStatusCd === 'ASC0000001'
            // 작업허가요청이 진행중인 경우
            || !this.workPermit.swpWorkRequestCd)
      },
      isWorking() {
        // 작업 승인이 났으며 작업이 진행중인 상황
        // - 승인완료  - 연장
        return this.isOld && (this.workPermit.swpStepCd === 'SS00000005' || this.workPermit.swpStepCd === 'SS00000010'
        || this.workPermit.swpStepCd === 'SS00000020' )
      },
      isWorkInfo() {
        // 작업 승인이 났으며 작업이 진행중인 상황
        // - 승인완료  - 연장
        return this.isOld && (this.workPermit.swpStepCd !== 'SS00000001')
      },
      isWriting() {
        // 허가서 작성중인 상황
        // - 작성중 - 결재중이 아닌경우
        // 작업허가요청이 진행중이 아닌 경우
        return (!this.isOld || this.workPermit.swpStepCd === 'SS00000001') 
          && this.workPermit.approvalStatusCd !== 'ASC0000001'
          && !this.workPermit.swpWorkRequestCd
      },
      saveBtnLabel() {
        return !this.isOld || this.workPermit.swpStepCd === 'SS00000001' ? '일괄저장' : '취소 - 연장 - 완료 처리'
      },
      requestBtnLabel() {
        return !this.isOld || this.workPermit.swpStepCd === 'SS00000001' ? '승인요청' : '취소 - 연장 - 완료 요청'
      },
      tableTimePickerOptions() {
        let returnData = {
          colName: 'overTime',
          start: '17:00',
          step: '00:10',
          end: '23:50'
        };
        if (this.workPermit.workTime && this.workPermit.workTime.length === 2) {
          returnData.start = this.workPermit.workTime[1]
        }
        return returnData;
      },
      approvalInfo() {
        return {
          sysApprovalRequestId: this.workPermit.sysApprovalRequestId, // 결재요청번호
          /**
           * 결재상태코드
           * ASC0000001	결재중
           * ASC0000002	반려
           * ASC9999999	결재완료
           */
          approvalStatusCd: this.workPermit.approvalStatusCd, 
          apprEditable: this.isOld && this.workPermit.swpStepCd === 'SS00000001', // 결재버튼 활성화 기준
          param: this.workPermit, // 결재 param
          approvalUrl: this.approvalUrl, // 결재 url
          isApproval: this.isApproval, // 결재 submit
          approvalTypeCd: 'APTC000001', // 결재유형코드
          approvalParamValue: { // 결재상세화면 파라미터
            sopWorkPermitId: this.workPermit.sopWorkPermitId,
            permitTypeCd: this.workPermit.permitTypeCd,
            isApprContent: true
          },
          approvalRequestName: this.workPermit.workSummary, // 결재요청명 (문서 title)
          approvalConnId: this.workPermit.sopWorkPermitId, // 결재연결용 업무일련번호 (문서 key)
        }
      },
      // [E] 결재관련 버튼 컨트롤
      workRequestDescription() {
        let text = '';
        if (this.workPermit.swpWorkRequestCd === 'SWR0000001') {
          text = `담당자가 현재 작업허가 요청 검토중입니다.`
        } else if (this.workPermit.swpWorkRequestCd === 'SWR0000005') {
          text = `담당자가 현재 작업허가 연장 검토중입니다.`
        } else if (this.workPermit.swpWorkRequestCd === 'SWR0000010') {
          text = `담당자가 현재 작업허가 취소 검토중입니다.`
        } else if (this.workPermit.swpWorkRequestCd === 'SWR0000015') {
          text = `담당자가 현재 작업허가 완료 검토중입니다.`
        }
        return text;
      },
      gasEditable() {
        return this.editable
          && !this.disabled
          && (this.workPermit.approvalStatusCd !== 'ASC0000001')
          || !this.isOld
      },
    },
    watch: {
      tabHeight() {
        let bol = window.innerWidth <= 768;
        this.cusTabHeight = (!bol ? this.tabHeight : 'auto');
      },
    },
    methods: {
      init() {
        // role setting
        this.editable = this.$route.meta.editable;
        // url setting
        this.detailUrl = selectConfig.sop.swp.workPermit.get.url
        this.listGasItemUrl = selectConfig.sop.swp.gas.list.url
        this.listSopDefaultUrl = selectConfig.sop.swp.workPermit.sopAssessment.default.url
        this.saveUrl = transactionConfig.sop.swp.workPermit.insert.url
        this.deleteUrl = transactionConfig.sop.swp.workPermit.delete.url
        this.approvalUrl = transactionConfig.sop.swp.workPermit.approval.url
        this.approvalReqUrl = transactionConfig.sop.swp.workPermit.approval.url + '/apprrequest'
        this.overUrl = transactionConfig.sop.swp.workPermit.over.url
        this.cancelUrl = transactionConfig.sop.swp.workPermit.cancel.url
        this.completeUrl = transactionConfig.sop.swp.workPermit.complete.url
        this.requestUrl = transactionPartnerConfig.sop.swp.workPermit.request.url
        this.rejectUrl = transactionPartnerConfig.sop.swp.workPermit.reject.url
        this.printUrl = selectConfig.sop.swp.workPermit.print.url
        // code setting
        // list setting
        this.getDetail();
      },
      getDetail(flag) {
        if (!this.tabItems) {
          this.tabItems = [];
        }
        this.tab = this.popupParam.permitTypeCd === 'SPT0000001' ? 'normal' : 'seal';
        if (this.isOld) {
          this.$http.url = this.$format(this.detailUrl, this.popupParam.sopWorkPermitId);
          this.$http.type = 'GET';
          this.$http.request((_result) => {
            this.$_.extend(this.workPermit, _result.data);
  
            if (this.workPermit.periodFlag === 'N') {
              this.workPermit.workTime = this.workPermit.workStartTime && this.workPermit.workEndTime ?
                [this.workPermit.workStartTime, this.workPermit.workEndTime] : []
            } else {
              this.workPermit.permitPeriod = [
                `${this.workPermit.permitDate} ${this.workPermit.workStartTime}`,
                `${this.workPermit.permitEndDate} ${this.workPermit.workEndTime}`
              ]
            }
  
            this.supWorks = this.$_.map(this.workPermit.supWorks, 'supplementWorkTypeCd')
            this.$set(this.commentsInfo, 'taskKey', this.workPermit.sopWorkPermitId)
  
            this.overFlag = this.workPermit.overs && this.workPermit.overs.length > 0
            this.cancelFlag = this.workPermit.swpStepCd === 'SS00000015' || this.workPermit.swpWorkRequestCd === 'SWR0000010'
            this.completeFlag = this.workPermit.swpStepCd === 'SS00000020' || this.workPermit.swpWorkRequestCd === 'SWR0000015'
            if (flag === 'save') {
              this.saveCall.saveCallData = uid();
            }
            this.setTabItems(flag);
  
            // 취소/연장/작업완요인 경우 
            const stepVisible = [
              'SS00000005',
              'SS00000010',
              'SS00000015',
              'SS00000020'
            ]
            if (stepVisible.indexOf(this.workPermit.swpStepCd) > -1 && !this.visible) {
              this.folder();
            }
          },);
        } else {
          this.workPermit.permitTypeCd = this.popupParam.permitTypeCd
          this.workPermit.applicationDeptCd = this.$store.getters.user.deptCd
          this.workPermit.applicationDeptName = this.$store.getters.user.deptName
          this.workPermit.applicationUserId = this.$store.getters.user.userId
          this.workPermit.applicationUserName = this.$store.getters.user.userName
          this.workPermit.vendorCd = this.$store.getters.user.userId
          this.workPermit.swpWorkClassCd = 'SWC0000001' // 외주작업
          this.workPermit.hazardPreventionPlanCd = 'HRP0000010' // 해당없음 default
          this.workPermit.permitDate = this.$comm.getToday();
          this.workPermit.workTime = ['08:00', '17:00'];
          
          if (this.workPermit.permitTypeCd === 'SPT0000005') {
            /**
             * 밀폐허가서인 경우
             * 
             */
            this.$http.url = this.listSopDefaultUrl;
            this.$http.type = 'GET';
            this.$http.request((_result) => {
              this.$set(this.workPermit, 'assessments', this.$_.map(_result.data, item => {
                return this.$_.extend(item, {
                  sopWorkSopAssessmentId: uid(),  // 작업허가서_작업위험성평가_일련번호
                  sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                  regUserId: this.$store.getters.user.userId,  // 등록자 ID
                  editFlag: 'C'
                })
              }))
            }, () => { });
          }
  
          this.setTabItems(flag);
        }
      },
      setTabItems(flag) {
        // this.tabItems = [];
        if (this.popupParam.permitTypeCd === 'SPT0000001') {
          // 일반 허가서
          if (this.checkTab('normal')) {
            this.tabItems.push({ componentKey: uid(),name: 'normal', icon: 'engineering',  class:'tab-lightblue', label: '일반', component: () => import(`${'./swpNormal.vue'}`) })
          }
        } else {
          // 밀폐 허가서
          if (this.checkTab('seal')) {
            this.tabItems.push({ componentKey: uid(),name: 'seal', icon: 'sensor_door',  class:'tab-brown', label: '밀폐', component: () => import(`${'./swpFire.vue'}`) })
          }
        }
        if (this.workPermit.supWorks && this.workPermit.supWorks.length > 0) {
          this.$_.forEach(this.workPermit.supWorks, supWork => {
            let checkIdx = this.$_.findIndex(this.tabItems, { supplementWorkTypeCd: supWork.supplementWorkTypeCd })
            if (checkIdx === -1) {
              let pushData = {}
              switch (supWork.supplementWorkTypeCd) {
                // 밀폐공간
                case 'SSWT000001':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'dangerous', label: '밀폐공간', component: () => import(`${'./swpConfinedSpace.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                // 정전
                case 'SSWT000005':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'flash_off', label: '정전', component: () => import(`${'./swpBlackout.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                // 화기
                case 'SSWT000010':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'local_fire_department', label: '화기', component: () => import(`${'./swpRadiation.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                // 고열
                case 'SSWT000015':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'thermostat', label: '고열', component: () => import(`${'./swpExcavation.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                // 고소
                case 'SSWT000020':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'stairs', label: '고소', component: () => import(`${'./swpHighPlace.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                // 중장비
                case 'SSWT000025':
                  pushData = {
                    componentKey: uid(),
                    name: supWork.supplementWorkTypeCd, class: 'tab-bluegrey', icon: 'agriculture', label: '중장비', component: () => import(`${'./swpHeavyEquipment.vue'}`),
                    supplementWorkTypeCd: supWork.supplementWorkTypeCd, supWork: supWork
                  }
                  break;
                default:
                // code block
              }
              if (this.checkTab(supWork.supplementWorkTypeCd)) {
                this.tabItems.push(pushData)
              }
            } else {
              this.$set(this.tabItems[checkIdx], 'supWork', supWork)
            }
          })
          let deleteItems = [];
          this.$_.forEach(this.tabItems, item => {
            if (this.$_.findIndex(this.workPermit.supWorks, (supWork) => {
              return supWork.supplementWorkTypeCd === item.supplementWorkTypeCd
            }) === -1 && (item.name !== 'normal' && item.name !== 'seal')) {
              deleteItems.push(item)
            }
          })
          if (deleteItems && deleteItems.length > 0) {
            this.$_.forEach(deleteItems, delItem => {
              this.tabItems = this.$_.reject(this.tabItems, delItem);
            });
          }
        } else {
          /**
           * 허가서를 제외한 나머지 보충작업 삭제
           */
          this.tabItems = this.$_.filter(this.tabItems, (item) => {
            return item.name === 'normal' || item.name === 'seal'
          })
        }
  
        if (this.tabItems && this.tabItems.length > 0) {
          let deleteItems = [];
          this.$_.forEach(this.tabItems, item => {
            if (this.$_.findIndex(this.workPermit.supWorks, { supplementWorkTypeCd: item.supplementWorkTypeCd }) === -1) {
              deleteItems.push(item)
            }
          });
  
          this.$_.forEach(deleteItems, item => {
            this.$set(this.tabItems, item, null)
          });
        }
  
        // 저장하고 난 후 조치
        if (flag === 'save') {
          this.saveAction = uid();
        }
      },
      checkTab(tab) {
        return this.$_.findIndex(this.tabItems, { name: tab }) === -1
      },
      /* eslint-disable no-unused-vars */
      changeSupWork(value) {
        /**
          보충작업이 입력되었을 경우
  
           - this.workPermit.supWorks에 영향을 준다.
           - this.setTabItems() method를 호출한다.
         */
  
        // ## 추가된 보충작업을 넣는 과정
        if (this.supWorks && this.supWorks.length > 0) {
          this.$_.forEach(this.supWorks, supWork => {
            if (this.$_.findIndex(this.workPermit.supWorks, { supplementWorkTypeCd: supWork }) === -1) {
              this.workPermit.supWorks.push({
                sopWorkPermitId: this.popupParam.sopWorkPermitId ? this.popupParam.sopWorkPermitId : uid(),  // 작업허가서 일련번호
                supplementWorkTypeCd: supWork,  // 보충작업구분
                workProposalNo: '',  // 작업 신청번호_방사선, 고소, 중장비
                workLocation: '',  // 작업장소_방사선, 고소, 중장비
                workSummary: '',  // 작업개요_고소, 방사선,굴착, 중장비
                issuedDeptCd: '',  // 발급자 부서코드
                issuedUserId: '',  // 발급자 ID
                approvalDeptCd: '',  // 승인자 부서코드
                approvalUserId: '',  // 승인자 ID
                maintenanceDeptCheckUserId: '',  // 정비부서 책임자 - 안전조치확인
                maintenanceDeptEntryUserId: '',  // 정비부서 입회자 - 안전조치확인
                relationCooperation1DeptCd: '',  // 관려부서 협조자1 부서코드
                relationCooperation1UserId: '',  // 관련부서 협조자1 ID
                relationCooperation2DeptCd: '',  // 관려부서 협조자2 부서코드
                relationCooperation2UserId: '',  // 관련부서 협조자2 ID
                specialRequirements: '',  // 특별요구사항
                closeMachine: '',  // (밀폐)장치명
                closeEntryResaon: '',  // (밀폐)출입사유
                entrants: [], // 입출입자
                deleteEntrants: [],
                closeExpectedRisk: '',  // (밀폐)예상위험
                blackoutCircuitBreaker: '',  // (정전)차단기기
                blackoutCircuitBreakerNo: '',  // (정전)차단기 번호
                blackoutPowerCloseTime: '',  // (정전) 전원차단시간
                blackoutPowerRecoveryRequestUserId: '',  // (정전)전원복구 요청자
                blackoutPowerRecoveryTime: '',  // (정전)전원복구 시간
                blackoutElectricBlockUserId: '',  // (정전)차단확인자(전기)
                blackoutMaintenanceBlockUserId: '',  // (정전)차단확인자(정비)
                radiationResponsibleUserId: '',  // (방사선)방사능 책임자
                heavyEquipSafetyCheckUserId: '',  // (중장비)안전조치 확인자
                heavyEquipManageUserId: '',  // (중장비)장비관리 책임자
                heavyEquipDriveUserId: '',  // (중장비)운전원
                heavyEquipDirectorRequirements: '',  // (중장비) 감독 요구사항
                heavyEquipRequireDeptRequirements: '',  // (중장비)요청부서 요구사항
                heavyEquipSupportDeptRequirements: '',  // (중장비) 지원부서 요구사항
                fireWatcherId: '',  // (화기)화재감시인ID
                fireWorkPlace: '',  // (화기)화기작업장소
                fireTypeWorkDetails: '',  // (화기)화기 종류 및 작업 내용
                regUserId: this.$store.getters.user.userId,  // 등록자 ID
                chgUserId: '',  // 수정자 ID
                checkResults: [], // 안전조치항목
                gases: [], // 가스항목측정 ** 사용하지 않는 보충작업도 존재하지만 빈 배열을 할당시켜 관리
                gasChecks: [], // 저장용
                deleteGasChecks: [],
                deleteGasCheckVals: [],
                editFlag: 'C',
                sketchSrc: '',
              })
            }
          })
        }
  
        // ## 삭제된 보충작업을 빼는 과정
        if (this.workPermit.supWorks && this.workPermit.supWorks.length > 0) {
          let deleteItems = [];
          this.$_.forEach(this.workPermit.supWorks, item => {
            if (this.$_.indexOf(this.supWorks, item.supplementWorkTypeCd) === -1) {
              deleteItems.push(item)
            }
          })
  
          if (!this.workPermit.deleteSupWorks) this.workPermit.deleteSupWorks = [];
          this.$_.forEach(deleteItems, deleteItem => {
            if (this.$_.findIndex(this.workPermit.deleteSupWorks, { supplementWorkTypeCd: deleteItem.supplementWorkTypeCd }) === -1
              && deleteItem.editFlag !== 'C') {
              this.workPermit.deleteSupWorks.push(deleteItem)
            }
            let idx = this.$_.findIndex(this.workPermit.supWorks, { supplementWorkTypeCd: deleteItem.supplementWorkTypeCd });
            this.workPermit.supWorks.splice(idx, 1);
          })
        }
        this.setTabItems();
      },
      qCardCancelClick() {
        if (this.editable&&!this.disabled&&!this.disableCancel) {
          this.cancelFlag = !this.cancelFlag
          this.changeCancel(this.cancelFlag)
        }
      },
      changeCancel(val) {
        if (val) {
          this.disableComplete = true;
        } else {
          this.disableComplete = false;
          this.workPermit.cancelRemark = '';
        }
      },
      qCardOverClick() {
        if (this.editable&&!this.disabled) {
          this.overFlag = !this.overFlag
          this.changeOver(this.overFlag)
        }
      },
      changeOver(val) {
        if (!val) {
          if (this.workPermit.overs && this.workPermit.overs.length > 0) {
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '연장을 해제하시면 연장정보가 사라집니다.\n진행하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                if (!this.workPermit.deleteOvers) this.workPermit.deleteOvers = [];
                this.$_.forEach(this.workPermit.overs, over => {
                  if (this.$_.findIndex(this.workPermit.deleteOvers, { sopOverResultId: over.sopOverResultId }) === -1) {
                    this.workPermit.deleteOvers.push(this.$_.clone(over))
                  }
                });
                this.$set(this.workPermit, 'overs', [])
              },
              // 취소 callback 함수
              cancelCallback: () => {
                this.overFlag = true;
              },
            });
          }
        }
      },
      qCardCompleteClick() {
        if (this.editable&&!this.disabled&&!this.disableComplete) {
          this.completeFlag = !this.completeFlag
          this.changeComplete(this.completeFlag)
        }
      },
      changeComplete(val) {
        if (val) {
          this.disableCancel = true;
        } else {
          this.disableCancel = false;
          this.workPermit.actionRemark = '';
          this.workPermit.workCompleteEntryUserId = '';
          this.workPermit.workCompleteWorkUserId = '';
          this.workPermit.workCompleteTime = '';
        }
      },
      addOver() {
        this.workPermit.overs.push({
          sopOverResultId: uid(),  // 작업허가서 연장정보 번호
          sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
          overTime: '',  // 연장시간
          overReason: '',  // 연장사유
          regUserId: this.$store.getters.user.userId,  // 등록자 ID
          editFlag: 'C'
        });
      },
      removeOver() {
        let selectData = this.$refs['tableOver'].selected;
        if (!selectData || selectData.length === 0) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '제외할 행을 지정하세요.', // 제외할 행을 지정하세요.
            type: 'warning', // success / info / warning / error
          });
        } else {
          if (!this.workPermit.deleteOvers) {
            this.workPermit.deleteOvers = [];
          }
          this.$_.forEach(selectData, item => {
            if (item.editFlag !== 'C'
              && this.$_.findIndex(this.workPermit.deleteOvers, { sopOverResultId: item.sopOverResultId }) === -1) {
              this.workPermit.deleteOvers.push(item)
            }
            this.workPermit.overs = this.$_.reject(this.workPermit.overs, item);
          });
          this.$refs['tableOver'].$refs['compo-table'].clearSelection();
        }
      },
      folder() {
        this.visible = !this.visible
        if (this.visible) {
          this.folderIcon = 'expand_less'
        } else {
          this.folderIcon = 'expand_more'
        }
      },
      changePeriodFlag() {
        if (this.workPermit.periodFlag === 'N') {
          let startDt = this.workPermit.permitPeriod[0].split(' ')
          let endDate = this.workPermit.permitPeriod[1].split(' ')
          let startTime = this.$comm.moment(`${this.$comm.getToday()} ${startDt[1]}`)
          let endTime = this.$comm.moment(`${this.$comm.getToday()} ${endDate[1]}`)
          if (endTime.diff(startTime) <= 0) {
            endTime = startTime
          }
          this.workPermit.permitDate = startDt[0]
          this.workPermit.permitEndDate = ''
          this.workPermit.permitPeriod = []
          this.workPermit.workTime = [startTime.format('HH:mm'), endTime.format('HH:mm')]
        } else {
          this.workPermit.permitPeriod = [
            `${this.workPermit.permitDate} ${this.workPermit.workTime[0]}`,
            `${this.$comm.moment(this.workPermit.permitDate).add(1, 'days').format('YYYY-MM-DD')} ${this.workPermit.workTime[1]}`
          ]
        }
      },
      requestWorkPermit() {
        if (this.isOld && this.workPermit.swpStepCd !== 'SS00000001') {
          // 승인완료 된 경우 취소/연장/완료 중 데이터가 들어간 경우에만 작동하도록 처리
          if (!this.cancelFlag && !this.overFlag && !this.completeFlag) {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '취소/연장/완료 데이터를 넣은 후 이용바랍니다.', // 취소/연장/완료 데이터를 넣은 후 이용바랍니다.
              type: 'warning', // success / info / warning / error
            });
            return;
          }
        }
        if (this.workPermit.isClosedSpaceEquip && this.workPermit.permitTypeCd === 'SPT0000001') {
          /**
           * 일반작업허가서에서 관련설비가 밀폐공간 정보를 가지고 있을 시 저장 X
           */
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '해당 설비는 밀폐작업허가서에서 적용 가능합니다.', // 해당 설비는 밀폐작업허가서에서 적용 가능합니다.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
        /**
         * 작업허가서 지도 
         */
        let check = true;
        if (this.workPermit.maps && this.workPermit.maps.length > 0) {
          this.$_.forEach(this.workPermit.maps, map => {
            check = map.resultTypes && map.resultTypes.length > 0
            if (!check) {
              return false;
            }
          })
        }
        if (!check) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '지도에 표시한 위치에 보충작업이 선정되지 않았습니다.', // 해당 설비는 밀폐작업허가서에서 적용 가능합니다.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
  
        this.$refs['editForm'].validate().then(_result => {
          if (_result) {
            eventBus.$emit('vaildForm', 'request')
          } else {
            window.getApp.$emit('APP_VALID_ERROR');
          }
        });
      },
      rejectWorkPermit() {
        this.$refs['editForm'].validate().then(_result => {
          if (_result) {
            eventBus.$emit('vaildForm', 'reject')
          } else {
            window.getApp.$emit('APP_VALID_ERROR');
          }
        });
      },
      saveWorkPermit() {
        if (this.workPermit.isClosedSpaceEquip && this.workPermit.permitTypeCd === 'SPT0000001') {
          /**
           * 일반작업허가서에서 관련설비가 밀폐공간 정보를 가지고 있을 시 저장 X
           */
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '해당 설비는 밀폐작업허가서에서 적용 가능합니다.', // 해당 설비는 밀폐작업허가서에서 적용 가능합니다.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
        /**
         * 작업허가서 지도 
         */
        let check = true;
        if (this.workPermit.maps && this.workPermit.maps.length > 0) {
          this.$_.forEach(this.workPermit.maps, map => {
            check = map.resultTypes && map.resultTypes.length > 0
            if (!check) {
              return false;
            }
          })
        }
        if (!check) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '지도에 표시한 위치에 보충작업이 선정되지 않았습니다.', // 해당 설비는 밀폐작업허가서에서 적용 가능합니다.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
        /**
         * 작업위험성평가 (JSA 참가자)
         */
        let jsaCheck = true;
        if (this.workPermit.assessUsers && this.workPermit.assessUsers.length > 0) {
          jsaCheck = false;
        }
        if (jsaCheck) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '관련정보의 작업 위험성평가 탭에서 JSA참가자를 추가하세요.', // 관련정보의 작업 위험성평가 탭에서 JSA참가자 5명 이상 추가하세요.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
        /**
         * 작업위험성평가 (안전조치사항)
         */
        let assessCheck = true;
        if (this.workPermit.assessments && this.workPermit.assessments.length > 2) {
          assessCheck = false;
        }
        if (assessCheck) {
          window.getApp.$emit('ALERT', {
            title: '안내', // 안내
            message: '관련정보의 작업 위험성평가 탭에서 안전조치사항 3개 이상 추가하세요.', // 관련정보의 작업 위험성평가 탭에서 안전조치사항 3개 이상 추가하세요.
            type: 'warning', // success / info / warning / error
          });
          return;
        }
        if (this.isOld) {
          this.saveUrl = transactionConfig.sop.swp.workPermit.update.url
          this.mappingType = 'PUT';
        } else {
          this.saveUrl = transactionConfig.sop.swp.workPermit.insert.url
          this.mappingType = 'POST';
          this.workPermit.swpStepCd = 'SS00000001' // 작성중
        }
  
        this.$refs['editForm'].validate().then(_result => {
          if (_result) {
            eventBus.$emit('vaildForm', 'save')
          } else {
            window.getApp.$emit('APP_VALID_ERROR');
          }
        });
      },
      validResult(_result, type) {
        if (_result) {
          if (type === 'save' || type === 'request' || type === 'reject') {
            this.workPermit.swpWorkRequestType = 'appr' // 승인
            let message = type === 'save' ? '저장하시겠습니까?' : '요청하시겠습니까?';
            /**
             * 1. 작업승인을 하지 않은 경우 일반 저장 처리
             * 2. 취소를 체크한 경우 작업완료 체크여부 확인
             *                      취소사유 기입 되었는지 확인
             * 3. 연장만 체크한 경우 연장 정보가 들어갔는지 확인
             * 4. 완료를 체크한 경우 취소 체크여부 확인
             */
            if (this.overFlag) {
              // 연장을 체크한 경우
              if (!this.workPermit.overs || this.workPermit.overs.length === 0) {
                window.getApp.$emit('ALERT', {
                  title: '안내', // 안내
                  message: '연장된 정보를 하나 이상 입력하십시오.', // 연장된 정보를 하나 이상 입력하십시오.
                  type: 'warning', // success / info / warning / error
                });
                return;
              }
              this.saveUrl = transactionConfig.sop.swp.workPermit.over.url
              this.mappingType = 'PUT';
              message = type === 'save' ? '작업 연장하시겠습니까?' : '작업 연장 요청하시겠습니까?'
              this.workPermit.swpWorkRequestType = 'over' // 연장
            }
            if (this.cancelFlag) {
              // 취소가 체크된 경우
              if (this.completeFlag) {
                window.getApp.$emit('ALERT', {
                  title: '안내', // 안내
                  message: '완료와 취소는 동시에 진행 할 수 없는 상태입니다.\n하나를 선택 하제 바랍니다.', // 완료와 취소는 동시에 진행 할 수 없는 상태입니다.\n하나를 선택 하제 바랍니다.
                  type: 'warning', // success / info / warning / error
                });
                return;
              } else if (!this.workPermit.cancelRemark) {
                window.getApp.$emit('ALERT', {
                  title: '안내', // 안내
                  message: '취소사유를 입력하시기 바랍니다.', // 취소사유를 입력하시기 바랍니다.
                  type: 'warning', // success / info / warning / error
                });
                return;
              }
              this.saveUrl = transactionConfig.sop.swp.workPermit.cancel.url
              this.mappingType = 'PUT';
              message = type === 'save' ? '작업 취소하시겠습니까?' : '작업 취소 요청하시겠습니까?'
              this.workPermit.swpWorkRequestType = 'cancel' // 취소
            }
            if (this.completeFlag) {
              // 완료를 체크한 경우
              if (this.cancelFlag) {
                window.getApp.$emit('ALERT', {
                  title: '안내', // 안내
                  message: '완료와 취소는 동시에 진행 할 수 없는 상태입니다.\n하나를 선택 하제 바랍니다.', // 완료와 취소는 동시에 진행 할 수 없는 상태입니다.\n하나를 선택 하제 바랍니다.
                  type: 'warning', // success / info / warning / error
                });
                return;
              }
              // 밀폐인 경우에만
              if (this.popupParam.permitTypeCd === 'SPT0000005') {
                if (!this.workPermit.gases || this.workPermit.gases.length === 0) {
                  window.getApp.$emit('ALERT', {
                    title: '안내', // 안내
                    message: '가스농도를 입력한 후에 완료처리 바랍니다.',
                    type: 'warning', // success / info / warning / error
                  });
                  return;
                } else if (!this.$comm.validTable([{
                    name: 'checkTime',
                    label: '가스농도측정 - 측정시간',
                    required: true
                  }], this.workPermit.gases)) {
                  return
                }
              }
              let confinedSpace = this.$_.find(this.workPermit.supWorks, { supplementWorkTypeCd: 'SSWT000001' })
              if (confinedSpace) {
                if (!confinedSpace.entrants || confinedSpace.entrants.length === 0) {
                  window.getApp.$emit('ALERT', {
                    title: '안내', // 안내
                    message: '밀폐공간 보충작업 입출입자 정보를 입력한 후에 완료처리 바랍니다.',
                    type: 'warning', // success / info / warning / error
                  });
                  return;
                } else if (!this.$comm.validTable([{
                    name: 'deptUserName',
                    label: '입출입자 - 출입자',
                    required: true
                  }], confinedSpace.entrants)) {
                  return
                }
              }
              this.saveUrl = transactionConfig.sop.swp.workPermit.complete.url
              this.mappingType = 'PUT';
              message = type === 'save' ? '작업 완료하시겠습니까?' : '작업 완료 요청하시겠습니까?'
              this.workPermit.swpWorkRequestType = 'complete' // 완료
            }
            /**
             * 유효성체크
             *
             * 각 탭 별 유효성 체크 필요 ** 해당 부분 만들어야 함
             */
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: message,
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                let promises = [
                  {
                    func: this.getGasItems,
                  },
                  {
                    func: this.setSaveValue,
                  },
                  {
                    func: type === 'save' ? this.saveValue : type === 'request' ? this.requestValue : this.rejectValue
                  },
                ];
                this.$comm.orderedPromise(promises);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
          } else {
            /**
             * 유효성체크
             *
             * 각 탭 별 유효성 체크 필요 ** 해당 부분 만들어야 함
             */
            window.getApp.$emit('CONFIRM', {
              title: '확인',
              message: '결재요청 하기 전 입력된 값을 저장합니다.\n 진행하시겠습니까?',
              // TODO : 필요시 추가하세요.
              type: 'info', // success / info / warning / error
              // 확인 callback 함수
              confirmCallback: () => {
                let promises = [
                  {
                    func: this.getGasItems,
                  },
                  {
                    func: this.setSaveValue,
                  },
                  {
                    func: this.approvalValue
                  },
                ];
                this.$comm.orderedPromise(promises);
              },
              // 취소 callback 함수
              cancelCallback: () => {
              },
            });
  
          }
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      },
      getGasItems() {
        return new Promise(resolve => {
          this.$http.url = this.listGasItemUrl;
          this.$http.type = 'GET';
          this.$http.param = {
            plantCd: this.workPermit.plantCd,
          }
          this.$http.request((_result) => {
            this.gasItems = _result.data
            resolve(true);
          }, (_error) => {
            resolve(false);
          });
        });
      },
      setSaveValue() {
        return new Promise(resolve => {
          this.workPermit.regUserId = this.$store.getters.user.userId
          this.workPermit.chgUserId = this.$store.getters.user.userId
  
          if (this.workPermit.periodFlag === 'N') {
            this.workPermit.workStartTime = this.workPermit.workTime[0]
            this.workPermit.workEndTime = this.workPermit.workTime[1]
          } else {
            let startDt = this.workPermit.permitPeriod[0].split(' ')
            let endDate = this.workPermit.permitPeriod[1].split(' ')
            this.workPermit.permitDate = startDt[0]
            this.workPermit.permitEndDate = endDate[0]
            this.workPermit.workStartTime = startDt[1]
            this.workPermit.workEndTime = endDate[1]
          }
  
          this.setGasData('permit')
          this.setGasData('supwork')
          resolve(true);
        });
      },
      setGasData(target) {
        let targetArray = target === 'permit' ? [this.workPermit] : this.workPermit.supWorks
        if (targetArray && targetArray.length > 0) {
          this.$_.forEach(targetArray, targetObj => {
  
            if (targetObj.gases && targetObj.gases.length > 0) {
              this.$_.forEach(targetObj.gases, gas => {
                let gasValues = [];
                if (this.gasItems && this.gasItems.length > 0) {
                  this.$_.forEach(this.gasItems, gasItem => {
                    if (gas.hasOwnProperty(gasItem.sopGasId)) {
                      gasValues.push({
                        sopGasCheckId: gas.sopGasCheckId,  // 가스농도측정번호
                        sopGasId: gasItem.sopGasId,  // 가스번호
                        measurement: gas[gasItem.sopGasId],  // 측정치
                        regUserId: gas.regUserId,  // 등록자 ID
                        chgUserId: gas.chgUserId,  // 수정자 ID
                        editFlag: gas.editFlag
                      })
                    }
                  })
                }
                if (!targetObj.gasChecks) targetObj.gasChecks = [];
                targetObj.gasChecks.push({
                  sopGasCheckId: gas.sopGasCheckId,  // 가스농도측정번호
                  sopWorkPermitId: this.workPermit.sopWorkPermitId,  // 작업허가서 일련번호
                  supplementWorkTypeCd: target === 'permit' ? '' : targetObj.supplementWorkTypeCd,  // 보충작업구분
                  checkTime: gas.checkTime,  // 점검시간
                  gasCheckMachine: gas.gasCheckMachine,  // 점검기기명
                  gasCheckUserId: gas.gasCheckUserId,  // 점검자
                  gasConfirmUserId: gas.gasConfirmUserId,  // 확인자(입회자)
                  regUserId: gas.regUserId,  // 등록자 ID
                  chgUserId: gas.chgUserId,  // 수정자 ID
                  editFlag: gas.editFlag,
                  gasValues: gasValues
                })
  
              });
            }
  
          })
        }
      },
      saveValue() {
        return new Promise(resolve => {
          this.isSave = !this.isSave
          resolve(true);
        });
      },
      requestValue() {
        return new Promise(resolve => {
          this.isRequest = !this.isRequest
          resolve(true);
        });
      },
      rejectValue() {
        return new Promise(resolve => {
          this.isReject = !this.isReject
          resolve(true);
        });
      },
      saveWorkPermitCallback(result) {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.popupParam.sopWorkPermitId = result.data
        this.getDetail('save');
      },
      requestWorkPermitCallback(result) {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.popupParam.sopWorkPermitId = result.data
        this.getDetail('save');
      },
      rejectWorkPermitCallback(result) {
        window.getApp.$emit('APP_REQUEST_SUCCESS');
        this.popupParam.sopWorkPermitId = result.data
        this.getDetail('save');
      },
      vendorSendDialogOpen() {
        this.vendorSendDialog.show = true;
      },
      closeVendorSendDialog() {
        this.vendorSendDialog.show = false;
        Object.assign(this.$data.vendorSendDialog, this.$options.data().vendorSendDialog);
      },
      returnDialogOpen() {
        this.returnDialog.show = true;
      },
      closeDialog() {
        this.returnDialog.show = false;
        Object.assign(this.$data.returnDialog, this.$options.data().returnDialog);
      },
      removeWorkPermit() {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '삭제하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.$http.url = this.$format(this.deleteUrl, this.popupParam.sopWorkPermitId);
            this.$http.type = 'DELETE';
            this.$http.request(() => {
              window.getApp.$emit('APP_REQUEST_SUCCESS');
              this.$emit('closePopup')
            },);
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      },
      approvalWorkPermit() {
        /**
         * 유효성 체크
         *  1. 작업위치 - 2021-12-21 김봉석 유효성 제거 희망
         *  2. 작업자 - 2022-06-07 김봉석 유효성 제거 희망
         *  3. 발급정보
         */
        let isIng = true;
        // if (isIng && (!this.workPermit.workers || this.workPermit.workers.length === 0)) {
        //   window.getApp.$emit('ALERT', {
        //     title: '안내', // 안내
        //     message: '작업자를 지정하시기 바랍니다.', // 작업자를 지정하시기 바랍니다.
        //     type: 'warning', // success / info / warning / error
        //   });
        //   isIng = false;
        // }
  
        if (isIng) {
          if (this.workPermit.isClosedSpaceEquip && this.workPermit.permitTypeCd === 'SPT0000001') {
            /**
             * 일반작업허가서에서 관련설비가 밀폐공간 정보를 가지고 있을 시 저장 X
             */
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '해당 설비는 밀폐작업허가서에서 적용 가능합니다.', // 해당 설비는 밀폐작업허가서에서 적용 가능합니다.
              type: 'warning', // success / info / warning / error
            });
            isIng = false;
          }
          if (!this.workPermit.issuedUserId || !this.workPermit.approvalUserId) {
            window.getApp.$emit('ALERT', {
              title: '안내', // 안내
              message: '허가서의 발급정보가 입력되지 않았습니다.', // 허가서의 발급정보가 입력되지 않았습니다.
              type: 'warning', // success / info / warning / error
            });
            isIng = false;
          } 
          // else {
          //   if (this.$_.findIndex(this.workPermit.supWorks, supWork => {
          //     return !supWork.issuedUserId || !supWork.approvalUserId
          //   }) > -1) {
          //     window.getApp.$emit('ALERT', {
          //       title: '안내', // 안내
          //       message: '발급정보가 입력되지 않은 보충작업이 있습니다.', // 발급정보가 입력되지 않은 보충작업이 있습니다.
          //       type: 'warning', // success / info / warning / error
          //     });
          //     isIng = false;
          //   }
          // }
        }
  
        if (isIng) {
          this.$refs['editForm'].validate().then(_result => {
            if (_result) {
              eventBus.$emit('vaildForm', 'appr')
            } else {
              window.getApp.$emit('APP_VALID_ERROR');
            }
          });
        }
      },
      approvalValue() {
        return new Promise(resolve => {
          this.isApproval = !this.isApproval
          resolve(true);
        });
      },
      // [S] 결재관련 
      approvalWorkPermitCallback(result) { // 결재관련 결재요청버튼 callback
        this.$refs['appr-btn'].apprRequestPop();
      },
      // [E]] 결재관련 
      // 출력물 다운로드 샘플
      printWorkPermit() {
        let thisVue = this;
        this.$http.url = this.$format(this.printUrl, this.popupParam.sopWorkPermitId);
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.workPermit.plantCd
        };
        this.$http.request(
          _result => {
            let fileOrgNm = this.workPermit.workSummary.substr(0, 30) + '.xlsx';
            let blob = thisVue.$comm.base64ToBlob(_result.data);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
            } else {
              let link = document.createElement('a');
              link.href = window.URL.createObjectURL(blob);
              link.download = fileOrgNm;
              link.click();
            }
          }, () => { }
        );
      }
    }
  };
  </script>
  <style lang="sass">
  .work-card
    .customDate,.customText
      padding-bottom: 0px !important
    .work-item
      padding-top:18px !important
      .q-field__inner
        padding-bottom: 0px !important
    label
      padding-bottom: 0px !important
  .work-title-text
    font-size: 15px
    font-weight: 800
  .bg-highLight
    border-width: 3px !important
    border-style: dashed !important
    border-color: hsla(0, 95%, 35%, 1) !important
  .work-permit-table
    .default-table
      margin-bottom: 0px
  </style>